import {
  getCurrentProfileSelect,
  PROFILE_KEY,
  PROFILES_DOMAIN,
  UNIT
} from '@gymaholic/packages'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import isLoadingReduxUtil from 'modules/redux/utils/is-loading'
import isSavingReduxUtil from 'modules/redux/utils/is-saving'
import { createSelector } from 'reselect'

export function isProfileLoadingSelector (id) {
  return (state) => {
    return isLoadingReduxUtil(state[PROFILES_DOMAIN].data[id])
  }
}

export function isProfileSavingSelector (id) {
  return (state) => {
    return isSavingReduxUtil(state[PROFILES_DOMAIN].data[id])
  }
}

export function getProfileByNameSelector (name) {
  return (state) => {
    const profiles = state[PROFILES_DOMAIN]
    const profileId = Object.keys(profiles.data).filter((profileId) => {
      return getValueReduxUtil(profiles.data[profileId], PROFILE_KEY.NAME) === name
    })

    return profiles.data[profileId]
  }
}

export const getHeightProfileSelect = createSelector(
  getCurrentProfileSelect,
  (profile) => getValueReduxUtil(profile, PROFILE_KEY.HEIGHT)
)

export const getHeightUnitProfileSelect = createSelector(
  getCurrentProfileSelect,
  (profile) => getValueReduxUtil(profile, PROFILE_KEY.HEIGHT_UNIT)
)

export const getBodyTypeProfileSelect = createSelector(
  getCurrentProfileSelect,
  (profile) => getValueReduxUtil(profile, PROFILE_KEY.BODY_TYPE)
)

export const getFitnessLevelProfileSelect = createSelector(
  getCurrentProfileSelect,
  (profile) => (
    getValueReduxUtil(profile, PROFILE_KEY.FITNESS_LEVEL)
  )
)

export const getGenderProfileSelect = createSelector(
  getCurrentProfileSelect,
  (profile) => getValueReduxUtil(profile, PROFILE_KEY.GENDER)
)

export const getWeightProfileSelect = createSelector(getCurrentProfileSelect,
  (profile) => (
    getValueReduxUtil(profile, PROFILE_KEY.WEIGHT)
  )
)

export const getWeightGoalProfileSelect = createSelector(getCurrentProfileSelect,
  (profile) => (
    getValueReduxUtil(profile, PROFILE_KEY.WEIGHT_GOAL)
  )
)

export const getGoalProfileSelect = createSelector(
  getCurrentProfileSelect,
  (profile) => (
    getValueReduxUtil(profile, PROFILE_KEY.GOAL)
  )
)

export const getWeeklyWorkoutsCountGoalProfileSelect = createSelector(
  getCurrentProfileSelect,
  (profile) => getValueReduxUtil(
    profile,
    PROFILE_KEY.WEEKLY_WORKOUTS_COUNT_GOAL
  )
)

export const getBirthdayProfileSelect = createSelector(
  getCurrentProfileSelect,
  (profile) => getValueReduxUtil(
    profile,
    PROFILE_KEY.BIRTHDAY
  )
)

export const getFirstNameProfileSelect = createSelector(
  getCurrentProfileSelect,
  (profile) => getValueReduxUtil(
    profile,
    PROFILE_KEY.FIRST_NAME
  )
)

export const getLastNameProfileSelect = createSelector(
  getCurrentProfileSelect,
  (profile) => getValueReduxUtil(
    profile,
    PROFILE_KEY.LAST_NAME
  )
)

export const getHeightDataSelect = createSelector(
  getHeightProfileSelect,
  getHeightUnitProfileSelect,
  (height, heightUnit) => {
    if (height && heightUnit === UNIT.IMPERIAL) {
      const splitHeight = height.toString().split('.')
      const ft = Number(splitHeight[0])
      const inch = Math.round(Number((height - ft).toFixed(2)) * 100)

      return {
        ft,
        inch,
        heightUnit
      }
    }

    if (height && heightUnit === UNIT.METRIC) {
      const cm = height * 100
      return {
        cm,
        heightUnit
      }
    }

    return {
      ft: null,
      inch: null,
      heightUnit
    }
  })

export const getMediaProfileSelect = createSelector(
  getCurrentProfileSelect,
  (profile) => getValueReduxUtil(
    profile,
    PROFILE_KEY.MEDIA
  )
)
